import { INSIGHTS } from "constants/action-types";
import { FluxStandardAction as Action } from "flux-standard-action";
import { ThunkAction } from "redux-thunk";
import { IStore } from "reducers";

export type FetchProductBadgesAction = Action<{ viewAsCompanyId?: string }, {}>;

export const fetchProductBadges = (
    viewAsCompanyId: string = null,
    force: boolean = false
): ThunkAction<void, IStore, FetchProductBadgesAction> => {
    return (dispatch, getState) => {
        const { badges } = getState().insights;
        // If we already have badges, don't fetch them again
        if (!force && !viewAsCompanyId && badges && typeof badges === "object" && Object.entries(badges).length > 0) {
            return;
        } else {
            dispatch({
                meta: {},
                payload: {
                    viewAsCompanyId,
                },
                type: INSIGHTS.FETCH_BADGES.START,
            });
        }
    };
};
